if(!window.theme._registeredSections['product'] === true){
  theme.Product = (function() {

    /**
     * Scripts run on the product template
     * @param       {HTMLElement} container The product container
     * @constructor
     */
    function Product(container) {
      this.container = container;
      // We need to use jQuery here for slate.variants
      this.$container = $(container);
      this.offer = this.container.dataset.offer;

      // Pickup the product data
      const jsonContainer = this.container.querySelector('[data-product-json-pdp]');
      let parsedData = null;
      try {
        parsedData = jsonContainer ? JSON.parse(jsonContainer.innerText) : null;
      } catch (e) {
        console.warn('PDP: invalid product JSON', e);
      }
      this.data = parsedData || {};

      // Setup variant selector with slate
      const options = {
        $container: this.$container,
        enableHistoryState: this.container.dataset.enableHistoryState || false,
        singleOptionSelector: '[data-single-option-selector-pdp]',
        originalSelectorId: '[data-product-select-pdp]',
        product: this.data,
      };

      this.variants = new slate.Variants(options);
      
      this.$container.on('variantChange', this.onVariantChanged.bind(this));
      this.$container.on('updateQuantity', this.updateQuantitySelector.bind(this));
      this.$container.on("variantImageChange", this.updateImages.bind(this)),
      // The add to cart listener
      this.addButtons = this.container.querySelectorAll('.pdp_main_product__add');
      this.updateQuantitySelector();
      const self = this;
      this.addButtons.forEach(addButton => {
        addButton.addEventListener('click', self.addClickHandler.bind(self));
      });

      this.requiredFields = this.container.querySelectorAll(
        '.gift-card-required'
      );
      if (this.requiredFields) {
        this.requiredFields.forEach(requiredField => {
          requiredField.addEventListener('keyup', self.checkGiftInput.bind(self));
        });
      }

      // Gift-card scheduled send date. Optional, so it is deliberately NOT a
      // `.gift-card-required` field — that class means "must not be empty".
      //
      // Validation TIMING is asymmetric on purpose. A native date input
      // updates its value on every keystroke of a segment, so while the
      // shopper types the year "2026" the value passes through 0002-, 0020-
      // and 0202-09-15 — all "in the past" — and validating on input/change
      // flashed "Choose a date from tomorrow onwards" at a date that was
      // about to be perfectly valid. So:
      //   - input/change (typing, the calendar popup, the mode toggle's
      //     dispatched event) may only CLEAR an error that is already showing;
      //   - blur (leaving the field) and the add-to-bag attempt run the full
      //     check and are the only places a date error can appear.
      //
      // The field is TWO inputs: `.gift-card-send-on` is the hidden ISO input
      // that posts (validated here); `[data-gc-date-display]` beside it is
      // the visible text the shopper reads and types into (gift-card-
      // calendar.js keeps the two in step). Visual state (aria-invalid, the
      // red border, focus on a blocked add) belongs on the visible one; a
      // hidden input has no box and cannot take focus.
      this.sendOnField = this.container.querySelector('.gift-card-send-on');
      if (this.sendOnField) {
        const sendOnWrap = this.sendOnField.closest('[data-gc-date-wrap]');
        this.sendOnDisplay = sendOnWrap
          ? sendOnWrap.querySelector('[data-gc-date-display]')
          : null;
        const sendOnVisual = this.sendOnDisplay || this.sendOnField;
        const softValidate = () => {
          if (sendOnVisual.getAttribute('aria-invalid') === 'true') {
            self.checkGiftInput();
          }
        };
        const fullValidate = self.checkGiftInput.bind(self);
        this.sendOnField.addEventListener('input', softValidate);
        this.sendOnField.addEventListener('change', softValidate);
        if (this.sendOnDisplay) {
          this.sendOnDisplay.addEventListener('input', softValidate);
          this.sendOnDisplay.addEventListener('blur', fullValidate);
        } else {
          this.sendOnField.addEventListener('blur', fullValidate);
        }
      }

      // Empty-field messages ("... is required") stay silent until the first
      // Add to Bag attempt flips this — see checkGiftInput. Format errors on
      // values the shopper actually typed surface live regardless.
      this.gcSubmitAttempted = false;

      // An attempt that never reaches addClickHandler. pdp.js's size gate
      // (the amount chips, on the gift card) intercepts the click in the
      // CAPTURE phase and stops its propagation while no amount is chosen,
      // so the handler above does not run and the recipient fields stayed
      // silent until the shopper picked an amount and clicked again. The
      // gate raises this event on the block instead, and the same attempt
      // validates the whole form so every missing field shows together.
      // Focus is left where the gate put it — on the first amount chip,
      // which is also the first invalid control in the form.
      this.container.addEventListener('pdp:add-blocked', () => {
        if (!((this.requiredFields && this.requiredFields.length) || this.sendOnField)) {
          return;
        }
        this.gcSubmitAttempted = true;
        this.checkGiftInput();
      });

      this.initImageCarousels();
      this.initImageZoom();
      this.initRelatedProducts();
      this.toggleShippingInfoPopup();
      this.shippingStockArray = [];
      
      document.querySelectorAll('.product .animate-start').forEach(function(el) {
        el.classList.remove('animate-start');
        // el.classList.add('animate-finish');
      });

      // Only initialise this stuff if the product is part of an offer.
      if (this.offer) {
        this.offerPopup = document.querySelector('.multibuy-offer__popup');
        this.offerPopupClose = document.querySelector(
          '.multibuy-offer__popup--close'
        );
        this.offerPopupMessage = document.querySelector(
          '.multibuy-offer__popup-message'
        );
        this.offerPopupLink = document.querySelector(
          '.multibuy-offer__popup-btn'
        );
        if (this.offerPopupClose) {
          this.offerPopupClose.addEventListener('click', this.toggleOfferPopup.bind(this));
        }
        const splitOffer = this.offer.split('-');

        /**
         * The safe number regex is here due to an unwanted error in how Lovisa set the
         * offer product tags via a csv import.
         *
         * Due to conversion errors offer tags ended up as:
         * offer:2-for-22Ê
         * offer:2-for-22.99Ä
         *
         * When trying to use Number() on the monetary value of the tag, the result ended up being NaN
         * which caused the shopify script to reduce the price of the multibuy items to 0.
         *
         * Run the regex on the offer parts to sanitise all characters from the individual part except for:
         * 1. All Digits 0-9
         * 2. Fullstop .
         * 3. Dash -
         */
        const safeOfferNumberRegex = /([^\d-.]|)|/g;
        const purgedOfferItems = splitOffer[0].replace(safeOfferNumberRegex, '');
        const purgedOfferMoney = splitOffer[splitOffer.length - 1].replace(safeOfferNumberRegex, '');
        this.offerItems = Number(purgedOfferItems);
        this.offerMoney = purgedOfferMoney;
      }

      var productOfferBadge = '.fancy-background';
      theme.CurrencySwitcher.switchCurrency(productOfferBadge);

      this.sizeguideTabs = document.querySelectorAll('.sizeguide__tab-header');
      if (this.sizeguideTabs) {
        this.sizeguideTabs.forEach(sizeguideTab => {
          sizeguideTab.addEventListener('click', this.updateSizeguideTab.bind(this));
        });
      }
      
      // const sizeGuideWrapper = document.getElementById('size-guide-dialog');
      // if (sizeGuideWrapper){

      //   const sizeGuideDialog = sizeGuideWrapper.querySelector('dialog.dialog__content');
      //   const overlay = sizeGuideWrapper.querySelector('.dialog__overlay');
      //   const hideTrigger = sizeGuideWrapper.querySelector('dialog.dialog__content [data-a11y-dialog-hide]');

      //   const closeDialog = () => {
      //     if (hideTrigger) {
      //       // Trigger the same path your close button uses
      //       hideTrigger.click();
      //     } else if (sizeGuideDialog) {
      //       // Fallback for native <dialog>
      //       if(sizeGuideDialog.close){
      //         sizeGuideDialog.close()
      //       }
      //       sizeGuideDialog.removeAttribute('open');
      //     }
      //   };

      //   // Close when clicking on the overlay
      //   if(overlay){
      //     overlay.addEventListener('click', (e) => {
      //       // Ensure it's the overlay itself (not a descendant)
      //       if (e.target === overlay) {
      //         closeDialog();
      //       }
      //     });
      //   }

      //   // Close when clicking outside the <dialog> content but inside the wrapper
      //   document.addEventListener('click', (e) => {
      //     // Only act if dialog is open
      //     if (!sizeGuideDialog || !sizeGuideDialog.open) return;

      //     const clickedInsideDialog = sizeGuideDialog.contains(e.target);
      //     const clickedInsideWrapper = sizeGuideWrapper.contains(e.target);

      //     console.log('e.target',e.target,'clickedInsideDialog', clickedInsideDialog,'clickedInsideWrapper',clickedInsideWrapper,'sizeGuideDialog.open',sizeGuideDialog.open);
      //     // If the click is within the wrapper but outside the dialog content
      //     if (clickedInsideWrapper && !clickedInsideDialog) {
      //       // If the element already has data-a11y-dialog-hide, let its own handler run
      //       if (!(e.target instanceof Element && e.target.closest('[data-a11y-dialog-hide]'))) {
      //         closeDialog();
      //       }
      //     }
      //   }, true); // capture to run early and avoid being blocked by other handlers

      //   // Close on Escape
      //   document.addEventListener('keydown', (e) => {
      //     if (e.key === 'Escape' && ( sizeGuideDialog && sizeGuideDialog.open)) {
      //       closeDialog();
      //     }
      //   });
      // }
      

    var sizeGuideWrapper = document.getElementById('size-guide-dialog');
    if (sizeGuideWrapper){

      var sizeGuideDialog = sizeGuideWrapper.querySelector('dialog.dialog__content');
      var overlay = sizeGuideWrapper.querySelector('.dialog__overlay');
      var hideTrigger = sizeGuideWrapper.querySelector('dialog.dialog__content [data-a11y-dialog-hide]');

      function closeDialog() {
        if (hideTrigger) {
          // Route through the same close button so all existing handlers/analytics fire
          hideTrigger.click();
        } else if (sizeGuideDialog) {
          if (typeof sizeGuideDialog.close === 'function') {
            sizeGuideDialog.close();
          }
          sizeGuideDialog.removeAttribute('open');
        }
      }

      // 1) Close when clicking on the overlay (custom overlay case)
      if (overlay) {
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay) {
            closeDialog();
          }
        });
      }

      // 2) Close when clicking the native backdrop (showModal case)
      //    Backdrop clicks target the <dialog>. We detect clicks outside its rect.
      if (sizeGuideDialog) {
        sizeGuideDialog.addEventListener('click', function (e) {
          // Only handle if the dialog itself received the event (not inner content)
          if (e.target !== sizeGuideDialog) return;

          var rect = sizeGuideDialog.getBoundingClientRect();
          var outside =
            e.clientX < rect.left ||
            e.clientX > rect.right ||
            e.clientY < rect.top ||
            e.clientY > rect.bottom;

          if (outside) {
            closeDialog();
          }
        });

        // For showModal(): Escape triggers 'cancel'
        sizeGuideDialog.addEventListener('cancel', function (e) {
          e.preventDefault(); // prevent native .close() so we can funnel through hideTrigger
          closeDialog();
        });
      }

      // 3) (Optional) If you rely on clicks in wrapper space (no native backdrop)
      //    This still helps when using a custom overlay region around the dialog.
      document.addEventListener('click', function (e) {
        if (!sizeGuideDialog || !sizeGuideDialog.open) return;

        var clickedInsideDialog = sizeGuideDialog.contains(e.target);
        var clickedInsideWrapper = sizeGuideWrapper.contains(e.target);

        if (clickedInsideWrapper && !clickedInsideDialog) {
          // let native [data-a11y-dialog-hide] elements handle themselves
          if (!closest(e.target, '[data-a11y-dialog-hide]')) {
            closeDialog();
          }
        }
      }, true);

      // 4) Fallback Escape handler for non-modal (open attribute) use
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeGuideDialog && sizeGuideDialog.open) {
          closeDialog();
        }
      });

      // Small helper to avoid needing Element.closest polyfills in older builds
      function closest(el, selector) {
        while (el && el.nodeType === 1) {
          if (el.matches ? el.matches(selector) : el.msMatchesSelector && el.msMatchesSelector(selector)) return el;
          el = el.parentElement;
        }
        return null;
      }
    }

      const modalTrigger = document.querySelectorAll('[data-a11y-dialog-show]');
      const modalClose = document.querySelectorAll('[data-a11y-dialog-hide]');
      const lockModalScroll = function() {
        if (document.body.classList.contains('modal-active')) return;

        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        document.body.dataset.modalScrollPosition = scrollPosition;
        document.body.style.top = `-${scrollPosition}px`;
        document.body.classList.add('modal-active');
      };
      const unlockModalScroll = function() {
        const scrollPosition = document.body.dataset.modalScrollPosition;

        document.body.classList.remove('modal-active');
        document.body.style.top = '';
        delete document.body.dataset.modalScrollPosition;

        if (scrollPosition !== undefined) {
          window.scrollTo(0, parseInt(scrollPosition, 10) || 0);
        }
      };

      if (modalTrigger.length) {
        for (let i = 0; i < modalTrigger.length; i++) {
          modalTrigger[i].addEventListener('click', lockModalScroll);
        }
      }

      if (modalClose.length) {
        for (let i = 0; i < modalClose.length; i++) {
          modalClose[i].addEventListener('click', unlockModalScroll);
        }
      }

      // WISHLIST button - observe class change and update aria-label / position
      const targetNode = this.container;
      const config = {attributes: true, childList: true, subtree: true};

      // Swym injects its wishlist button asynchronously into its own mount
      // point; park it in the theme's chosen slot once it appears.
      function moveSwymWishlistIntoSlot() {
        try {
          const addToCartWrapper = targetNode.querySelector('.product-form__add-to-cart');
          if (!addToCartWrapper) return;

          // The redesigned PDP shows the wishlist heart in the title meta
          // cluster, which sits outside the add-to-cart wrapper, so look for
          // the slot document-wide first. The old quantity-wrapper targets
          // remain as a fallback for surfaces that still render them
          // (quickview, tagalys).
          const quantityWrapper =
            document.querySelector('[data-pdp-wishlist-slot]') ||
            addToCartWrapper.querySelector('.product-form__add_quantity') ||
            addToCartWrapper.querySelector('.product-form__quantity');
          if (!quantityWrapper) return;

          const swymWrapper = addToCartWrapper.querySelector('.swym-atw-btn-wrapper');
          if (!swymWrapper) return;

          const wishlistContainer =
            swymWrapper.querySelector('#swym-atw-button-container') ||
            swymWrapper.querySelector('.swym-atw-button-container');
          if (!wishlistContainer) return;

          if (!quantityWrapper.contains(wishlistContainer)) {
            quantityWrapper.appendChild(wishlistContainer);
          }

          const addButton = addToCartWrapper.querySelector('.pdp_main_product__add');
          const addButtonParent =
            addToCartWrapper.querySelector('.product-form__add') || addToCartWrapper;
          if (addButton && addButtonParent && addButton.parentElement !== addButtonParent) {
            addButtonParent.appendChild(addButton);
          }

          if (!swymWrapper.querySelector('*')) {
            if (swymWrapper.parentNode) {
              swymWrapper.parentNode.removeChild(swymWrapper);
            }
          }
        } catch (e) {
          // Fail silently to avoid breaking product script
        }
      }

      // Function to execute when mutations are observed
      function callback(mutations, observerInstance) {
        for (let mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            const el = mutation.target;
            if (el.classList.contains('bookmarked')) {
              el.setAttribute("aria-label", `Remove ${el.dataset.productTitle ? el.dataset.productTitle + ' ' : ''}from wishlist`);
            } else if (el.classList.contains('unbookmarked')) {
              el.setAttribute("aria-label", `Add ${el.dataset.productTitle ? el.dataset.productTitle + ' ' : ''}to wishlist`);
            }
          }

          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes || []);
            const hasSwymNode = addedNodes.some(node => {
              if (!(node && node.nodeType === 1)) return false;
              if (node.classList && node.classList.contains('swym-atw-btn-wrapper')) return true;
              if (node.id === 'swym-atw-button-container') return true;
              if (typeof node.querySelector === 'function') {
                return !!(
                  node.querySelector('.swym-atw-btn-wrapper') ||
                  node.querySelector('#swym-atw-button-container')
                );
              }
              return false;
            });

            if (hasSwymNode) {
              moveSwymWishlistIntoSlot();
            }
          }
        }
      }

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
      // Ensure correct initial placement if Swym has already rendered
      moveSwymWishlistIntoSlot();


      let viewItemListDataLayerDelay;
      const handleViewRelatedProductsEvent = () => {
        const relatedProductsData = window.theme.relatedProductsData;
        if (!relatedProductsData) { return; }

        const {items: allResults, itemListId, itemListName, itemListType} = relatedProductsData;
        let skusComingIntoView = [];

        const viewItemListEvent = (itemList = []) => {
          if (!itemList.length) { return; }
          if (viewItemListDataLayerDelay) {
            clearTimeout(viewItemListDataLayerDelay);
          }

          viewItemListDataLayerDelay = setTimeout(() => {
            let promotionEvent = JSON.parse(localStorage.getItem('ga4-promotionView') || '{}');
            const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
            const menuNavigationState = menuNavigationAction.menu_navigation_state || {};
            window.pushEvent({
              event: 'view_item_list',
              menu_navigation_state: menuNavigationState,
              ecommerce: Object.assign(promotionEvent, {
                items: itemList,
                item_list_id: itemListId,
                item_list_name: itemListName,
                item_list_type: itemListType,
                item_total_count: allResults.length,
                item_visible_count: window.theme.relatedProductsData.itemsVisible.length,
              }),
            }, 'ecommerce');

            skusComingIntoView = [];
          }, 1000);
        };

        const productCards = document.querySelectorAll('.related-products .product-card');
        if (productCards.length) {
          productCards.forEach((card) => {
            let isVisibleNow = window.theme.isElementVisibleInViewport(card);
            card.setAttribute('data-visible-by-default', isVisibleNow);
            if (isVisibleNow) {
              skusComingIntoView.push(card.getAttribute('data-sku'));
            }

            const handleIntersection = (entries, observer) => {
              entries.forEach(entry => {
                const visibleByDefault = card.getAttribute('data-visible-by-default') || false;
                isVisibleNow = window.theme.isElementVisibleInViewport(card, true);
                if (entry.intersectionRatio > 0) {
                  observer.unobserve(entry.target);

                  card.setAttribute('data-visible-in-viewport', isVisibleNow);
                  if (isVisibleNow) {
                    skusComingIntoView.push(card.getAttribute('data-sku'));
                    const itemsInViewport = allResults.filter((item) => skusComingIntoView.includes(item.item_id));
                    relatedProductsData.itemsVisible = relatedProductsData.itemsVisible || [];
                    const visibleItems = itemsInViewport.map((item) => {
                      const itemExists = relatedProductsData.itemsVisible.find((listItem) => listItem.item_id === item.item_id);
                      const newItem = item;
                      // eslint-disable-next-line no-eval
                      newItem.visible_by_default = visibleByDefault;

                      if (!itemExists) {
                        window.theme.relatedProductsData.itemsVisible.push(newItem);
                      }
                      return newItem;
                    });
                    viewItemListEvent(visibleItems);
                  }
                }
              });
            };
            const observer = new IntersectionObserver(handleIntersection);
            observer.observe(card);
          });
        }
      };

      // DATALAYER push data
      // Guard: skip the productView push when product data was unavailable at
      // init (this.data fell back to {}), matching the add-to-cart guard.
      if (this.data && this.data.title) {
      let promotionEvent = JSON.parse(localStorage.getItem('ga4-promotionView') || '{}');
      const menuNavigationAction = JSON.parse(localStorage.getItem('ga4-navigationClick') || '{}');
      const menuNavigationState = menuNavigationAction.menu_navigation_state || {};

      // Added globale parameter for the US store
      if (window.theme.settings.store == 'US') {
        var globale = "false";
        if (window.Shopify.currency.active != 'USD') {
          var globale = "true";
        }
        window.pushEvent({
          event: 'productView',
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEvent, {
            currencyCode: window.theme.currency,
            detail: {
              products: [
                {
                  name: this.data.title.replace(/["']/g, ''),
                  id: `${this.data.id}_${this.data.selected_or_first_available_variant.id}`,
                  price: this.data.price/100,
                  brand: this.data.vendor,
                  category: this.data.type,
                  GlobalE:globale
                }
              ]
            }
          }),
        });
      } else {
        window.pushEvent({
          event: 'productView',
          menu_navigation_state: menuNavigationState,
          ecommerce: Object.assign(promotionEvent, {
            currencyCode: window.theme.currency,
            detail: {
              products: [
                {
                  name: this.data.title.replace(/["']/g, ''),
                  id: `${this.data.id}_${this.data.selected_or_first_available_variant.id}`,
                  price: this.data.price/100,
                  brand: this.data.vendor,
                  category: this.data.type
                }
              ]
            }
          }),
        });
      }
      }
    }

    Product.prototype.updateSizeguideTab = function(event) {
      const clickedTab = event.target;
      this.sizeguideTabs.forEach(tab => {
        tab.classList.remove('sizeguide__tab-header--active');
      });
      clickedTab.classList.add('sizeguide__tab-header--active');
      const tabIndex = clickedTab.getAttribute('data-index');
      const tabsContent = document.querySelectorAll('.sizeguide__tab-content');
      if (tabsContent) {
        tabsContent.forEach(tabContent => {
          tabContent.classList.remove('sizeguide__tab-content--active');
        });
      }
      const selectedTabContent = document.querySelector('[data-content-index="' + tabIndex + '"]');
      if (selectedTabContent) {
        selectedTabContent.classList.add('sizeguide__tab-content--active');
      }
    };

    Product.prototype.updateQuantitySelector = function(){
      const quantitySelector = this.container.querySelector('.quantity-selector[data-component="QuantitySelector"]');
      let currentVariant = this.variants.currentVariant;
      let quantity = currentVariant.inventory_quantity;
      let cartData = theme.sideCart.cart;
        let selectSkuItemQty = 0;
        
        if (cartData && cartData.items && Array.isArray(cartData.items)) {
          for (let i = 0; i < cartData.items.length; i++) {
              const currentItem = cartData.items[i]; 
              if (currentItem && currentItem.sku && currentItem.sku === currentVariant.sku) {
                  selectSkuItemQty += (typeof currentItem.quantity === 'number' ? currentItem.quantity : 0);
              }
          }
        }

      if(quantitySelector){
        const skuParagraph = this.$container.find('#tab-pd p.product-sku');
        if (skuParagraph.length > 0) {
            let skuQty = skuParagraph.data('shipping-stock-qty');
            if(!isNaN(skuQty) && skuQty !== null && skuQty !== undefined){
              quantity = skuQty;
            }
        }
        quantity = quantity - selectSkuItemQty;
        if(quantity < 1){quantity = 1;}
        if(quantitySelector._quantitySelector){
          quantitySelector._quantitySelector.max = quantity;
          if(quantitySelector._quantitySelector.input.value > quantity){
            quantitySelector._quantitySelector.input.value = quantity;
          }
          
          if(quantitySelector.querySelector('input.quantity-selector__quantity')){
            quantitySelector.querySelector('input.quantity-selector__quantity').setAttribute('max',quantity);
          }
          quantitySelector._quantitySelector.onInputUpdated();
        }
      }
    }

    /**
     * The variant change handler
     */
    Product.prototype.onVariantChanged = function(event) {
      const variant = event.variant;
      this.variants.currentVariant = variant;
      if (this.container.querySelector('[data-product-price]')) {
        let moneyFormat = window.theme.moneyFormat || null;
        moneyFormat = moneyFormat.replace(window.theme.currentCurrencySymbol,'');
        if(window.theme.currencyFormat == 'money_format'){
          moneyFormat = moneyFormat.replace(window.theme.currentCurrency,'');
        }
        this.productPrice = this.container.querySelector('[data-product-price]');
        this.priceWrappers = this.container.querySelectorAll('[data-price-wrapper]');
        Array.from(this.priceWrappers).forEach(function(priceWrapper){
          let comparePriceWrapper = priceWrapper.querySelector('[data-compare-price-wrapper]');
          let comparePriceText = priceWrapper.querySelector('[data-compare-price]');
          let mainPriceText = priceWrapper.querySelector('[data-product-price]');
          let currencySymbol = priceWrapper.querySelector('[data-currency-symbol]');
          if(mainPriceText) mainPriceText.innerHTML = slate.Currency.formatMoney(variant.price, moneyFormat)
          if(priceWrapper){
            priceWrapper.classList.toggle('pdp-on-sale',variant.compare_at_price > variant.price? true:false);
          }
          if(comparePriceText){
            comparePriceText.innerHTML = variant.compare_at_price > variant.price ? slate.Currency.formatMoney(variant.compare_at_price, moneyFormat) : "";
          }
          if(comparePriceWrapper){
            comparePriceWrapper.classList.toggle('hide',variant.compare_at_price > variant.price ? false : true);
          }
          if(currencySymbol) {
            currencySymbol.classList.toggle('sale-price-text-color',variant.compare_at_price > variant.price ? true : false);
          }
          if(mainPriceText){
            if(variant.compare_at_price > variant.price){
              // priceWrapper.classList.add('pdp-on-sale');
              mainPriceText.setAttribute('data-product-original-price','');
              // if(currencySymbol) currencySymbol.classList.add('sale-price-text-color');
              // comparePriceText.innerHTML = slate.Currency.formatMoney(variant.compare_at_price, moneyFormat);
              // comparePriceWrapper.classList.remove('hide');
            }else{
              // priceWrapper.classList.remove('pdp-on-sale');
              // if(currencySymbol) currencySymbol.classList.remove('sale-price-text-color');
              mainPriceText.removeAttribute('data-product-original-price');
              // comparePriceText.innerHTML = '';
              // comparePriceWrapper.classList.add('hide');
            }
          }
        })
        // if (this.productPrice) this.productPrice.innerHTML = slate.Currency.formatMoney(variant.price, moneyFormat);
        // Every `.product-sku` node, not just the first. The redesigned
        // Product Information card renders a visible SKU line, and it precedes
        // the legacy `#tab-pd p.product-sku` in DOM order. With
        // `querySelector` the first match won and the `#tab-pd` node kept the
        // SKU of whichever size loaded first — which header.js reads back
        // (getSkuNumber -> getStockFromSKU) on every size change to look up
        // shipping-branch inventory, so the Delivery card could report the
        // stock of the previously selected size. `data-shipping-stock-qty` is
        // read off the same node.
        //
        // The visible label is read off the node rather than hardcoded, so the
        // copy stays owned by Liquid/locale files. `data-sku` carries the bare
        // value for machines: header.js's getSkuNumber() used to string-match
        // the rendered text and bail unless it began with the literal "SKU",
        // which meant the BOPIS stock lookup silently returned null on every
        // non-English locale.
        //
        // Separator: ": ", matching what Liquid renders server-side
        // (pdp-product-information.liquid, the #tab-pd node and the gift-card
        // line all use ": "). It used to write " - ", so the visible SKU line
        // silently changed format the first time a shopper picked a size, on
        // a page where the value itself had not changed. header.js's
        // text-parse fallback strips both separators, and it only runs when
        // `data-sku` is missing, so the rendered text is free to change.
        //
        // The value is guarded once and reused: an unguarded `variant.sku`
        // printed the literal "undefined" for a variant with no SKU.
        this.productSku = this.container.querySelectorAll('.product-sku');
        this.productSku.forEach(function(skuNode) {
          const skuLabel = skuNode.getAttribute('data-sku-label') || 'SKU';
          const skuValue = variant.sku || '';
          skuNode.setAttribute('data-sku', skuValue);
          skuNode.innerText = skuLabel + ': ' + skuValue;
          // A variant with no SKU would otherwise leave a bare "SKU:" label
          // behind. `hidden` (not removal) keeps the node — header.js reads
          // its data-sku and jQuery data off it, and both survive hiding.
          skuNode.hidden = !skuValue;
        });
      }

      const btnOutOfStock = this.container.querySelector('.btn__outofstock');
      const pdpFrmQty = this.container.querySelector('.product-form__quantity');

      if (variant.available) {
        this.addButtons.forEach(addButton => {
          addButton.removeAttribute('disabled');
          addButton.querySelector('span').innerText = theme.strings.addToCart;
          if (pdpFrmQty && pdpFrmQty.classList.contains('disabled')) {
            pdpFrmQty.classList.remove('disabled');
          }
        });
        if (btnOutOfStock) {
          btnOutOfStock.style.display = 'none';
        }
      } else {
        this.addButtons.forEach(addButton => {
          addButton.setAttribute('disabled', 'disabled');
          // "Out of Stock", not "Sold Out": with no back-in-stock trigger on
          // the PDP (product-form.liquid) this disabled button IS the
          // out-of-stock state, and its label must match what Liquid renders.
          addButton.querySelector('span').innerText = theme.strings.outOfStock;
          if (pdpFrmQty) {
            pdpFrmQty.classList.add('disabled');
          }
        });
        if (btnOutOfStock) {
          btnOutOfStock.style.display = 'block';
        }
      }
      this.updateQuantitySelector(); 
      
      const getInventoryData = () => {
        const scriptTag = document.getElementById('VariantInventoryJson');
        if (!scriptTag) return null;
        try {
          return JSON.parse(scriptTag.innerHTML);
        } catch (e) {
          console.error("JSON parse error for InventoryData:", e);
          return null;
        }
      };
      // Update Stock Badge — the only badge left in .pdp-product__badges. The
      // gallery badges and the display-limit sweep that capped them are retired.
      const badgeContainer = this.container.querySelector('.pdp-product__badges');
      const stockBadge = this.container.querySelector('[data-stock-badge]');

      if (badgeContainer && stockBadge && variant) {
        // get inventory data
        const inventoryData = getInventoryData();
        // get current variant inventory quantity

        // safely get inventory quantity
        let inventoryQuantity = 0;
        if (inventoryData && inventoryData.variants) {
          const currentVariantData = inventoryData.variants.find(v => v.id === variant.id);
          inventoryQuantity = currentVariantData ? currentVariantData.inventory_quantity : 0;
        }
       
        const maxStock = parseInt(stockBadge.getAttribute('data-max-stock')) || 0;
        const stockBuffer = parseInt(stockBadge.getAttribute('data-stock-buffer')) || 0;
        const threshold = maxStock + stockBuffer;

        const isStockBadgeValid = variant.inventory_management === 'shopify' && 
                            variant.inventory_policy === 'deny' && 
                            inventoryQuantity > 0 && 
                            inventoryQuantity <= threshold;

        if (isStockBadgeValid) {
          if (inventoryQuantity <= stockBuffer) {
            stockBadge.innerHTML = stockBadge.getAttribute('data-low-stock-text') || '';
          } else {
            const startText = stockBadge.getAttribute('data-start-text') || '';
            const endText = stockBadge.getAttribute('data-end-text') || '';
            const displayQuantity = inventoryQuantity - stockBuffer;
            stockBadge.innerHTML = `${startText} <span class="stock-count">${displayQuantity}</span> ${endText}`;
          }
          stockBadge.classList.remove('hide');
        } else {
          stockBadge.classList.add('hide');
        }
      }
    };

    Product.prototype.getUniqueOffer = function(offer, quantity) {
      const getUsedOffers = localStorage.getItem('multibuy');
      let random = Math.floor(Math.random() * 100 + 1);
      let generatedOffer = '';
      let addedQty = 1;
      let allOffers = [];
      let generatedQtyOffer = '';
      let isAdded = false;
      function getSingleOffer(singleOffer) {
        return singleOffer.includes(generatedOffer);
      }
      if (getUsedOffers) {
        allOffers = getUsedOffers.split(',');
        const alreadyAdded = allOffers.filter(singleOffer => singleOffer.includes(offer));
        if (alreadyAdded) {
          alreadyAdded.forEach(addedOffer => {
            addedQty = parseInt(addedOffer.split(':')[1], 10);
            if (addedQty < this.offerItems) {
              addedQty += quantity;
              generatedOffer = addedOffer.split(':')[0];
              generatedQtyOffer = generatedOffer + ':' + addedQty;
              const offerIndex = allOffers.indexOf(addedOffer);
              allOffers[offerIndex] = generatedQtyOffer;
              isAdded = true;
            }
          });
        } else {
          addedQty = quantity;
          generatedOffer = offer + '-' + random;
          generatedQtyOffer = generatedOffer + ':' + addedQty;
          allOffers.push(generatedQtyOffer);
          isAdded = true;
        }
      } else {
        addedQty = quantity;
        generatedOffer = offer + '-' + random;
        generatedQtyOffer = generatedOffer + ':' + addedQty;
        allOffers.push(generatedQtyOffer);
        isAdded = true;
      }
      if (!isAdded) {
        let notAdded = true;
        addedQty = quantity;
        allOffers = getUsedOffers.split(',');
        while (notAdded) {
          random = Math.floor(Math.random() * 100 + 1);
          generatedOffer = offer + '-' + random;
          generatedQtyOffer = generatedOffer + ':' + addedQty;
          const alreadyAdded = allOffers.filter(getSingleOffer);
          if (alreadyAdded.length === 0) {
            notAdded = false;
            allOffers.push(generatedQtyOffer);
          }
        }
      }
      try {
        localStorage.setItem('multibuy', allOffers.join(','));
      } catch (e) {
        console.error("Failed to save multibuy to localStorage:", e);
      }
      return generatedOffer;
    };

    Product.prototype.checkMultibuyQty = function(quantity) {
      const getUsedOffers = localStorage.getItem('multibuy');
      const offer = this.offer.split('-')[0] + '-' + this.offer.split('-')[2];
      const offerQty = parseInt(this.offer.split('-')[0], 10);
      const numberOffers = quantity / offerQty;
      const generatedQty = [];
      let quantityLeft;
      if (getUsedOffers) {
        const allOffers = getUsedOffers.split(',');
        const alreadyAdded = allOffers.filter(singleOffer => singleOffer.includes(offer));
        if (alreadyAdded) {
          alreadyAdded.forEach(addedOffer => {
            const addedQty = parseInt(addedOffer.split(':')[1], 10);
            if (!(addedQty === offerQty)) {
              if (addedQty + quantity > offerQty) {
                quantityLeft = quantity;
                for (let i = 0; i < numberOffers; i++) {
                  if (i === 0) {
                    generatedQty.push(offerQty - addedQty);
                    quantityLeft -= offerQty - addedQty;
                  } else if (i > 0 && quantityLeft > offerQty) {
                    generatedQty.push(offerQty);
                    quantityLeft -= offerQty;
                  } else {
                    generatedQty.push(quantityLeft);
                    quantityLeft -= quantityLeft;
                  }
                }
              } else {
                generatedQty.push(quantity);
              }
            }
          });
        } else if (quantity > offerQty) {
          quantityLeft = quantity;
          for (let i = 0; i < numberOffers; i++) {
            if (quantityLeft > offerQty) {
              generatedQty.push(offerQty);
              quantityLeft -= offerQty;
            } else {
              generatedQty.push(quantityLeft);
              quantityLeft -= quantityLeft;
            }
          }
        } else {
          generatedQty.push(quantity);
        }
      } else if (quantity > offerQty) {
        quantityLeft = quantity;
        for (let i = 0; i < numberOffers; i++) {
          if (quantityLeft > offerQty) {
            generatedQty.push(offerQty);
            quantityLeft -= offerQty;
          } else {
            generatedQty.push(quantityLeft);
            quantityLeft -= quantityLeft;
          }
        }
      } else {
        generatedQty.push(quantity);
      }

      if (generatedQty.length === 0) {
        if (quantity > offerQty) {
          quantityLeft = quantity;
          for (let i = 0; i < numberOffers; i++) {
            if (quantityLeft > offerQty) {
              generatedQty.push(offerQty);
              quantityLeft -= offerQty;
            } else {
              generatedQty.push(quantityLeft);
              quantityLeft -= quantityLeft;
            }
          }
        } else {
          generatedQty.push(quantity);
        }
      }

      if (quantityLeft > 0) {
        generatedQty.push(quantityLeft);
      }
      return generatedQty;
    };

    Product.prototype.checkGiftInput = function() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // let isFilled = true;
      let formIsValid = true;

      const form = this.container.querySelector('.product__form');

      // Empty-field messages are gated on the first Add to Bag attempt.
      // Keyup on ANY required field validates them ALL, so without the gate
      // a shopper typing their way down the form saw "Email is required."
      // under fields they simply had not reached yet. A field the shopper
      // HAS typed into that fails its format still errors live.
      const attempted = this.gcSubmitAttempted === true;

      this.requiredFields.forEach(requiredField => {
        // "Myself" hides the recipient block and disables its inputs. A
        // disabled field is out of the order entirely (the native submit
        // and the properties sweep both skip it), so it is not required
        // either, and any error it was showing is withdrawn.
        if (requiredField.disabled) {
          requiredField.setAttribute('aria-invalid', false);
          const disabledAlert = requiredField.parentNode.querySelector(
            '.field__error-alert'
          );
          if (disabledAlert) {
            disabledAlert.style.display = 'none';
          }
          return;
        }

        let isFilled = true;

        if (requiredField.type === 'email') {
          isFilled = re.test(requiredField.value.toLowerCase());
        } else if (requiredField.value === '') {
          isFilled = false;
        } else {
          isFilled = true;
        }

        if (!isFilled) {
          formIsValid = false;
        }

        const fieldEmpty = requiredField.value === '';
        const showError = !isFilled && (attempted || !fieldEmpty);

        const errorAlert = requiredField.parentNode.querySelector(
          '.field__error-alert'
        );

        if (!showError) {
          requiredField.setAttribute('aria-invalid', false);
          if (errorAlert) {
            errorAlert.style.display = 'none';
          }
        } else {
          requiredField.setAttribute('aria-invalid', true);
          if (errorAlert) {
            // Two failure copies where the markup provides them: an EMPTY
            // field reads its data-required-text ("... is required"), a
            // filled-but-malformed one (only the email can be) reads
            // data-invalid-text ("Oops! Looks like this email isn't
            // valid..."). Spans without the data attributes keep whatever
            // text they were rendered with.
            const failedFormat = !fieldEmpty && errorAlert.dataset.invalidText;
            const message = failedFormat
              ? errorAlert.dataset.invalidText
              : errorAlert.dataset.requiredText;
            if (message) {
              errorAlert.textContent = message;
            }
            errorAlert.style.display = 'block';
          }
        }
      });

      // Scheduled send date. This validation is the ONLY safety net: Disco
      // confirmed (Aug 2026) that an invalid or past `_delivery_date` is
      // treated as nil downstream and the card sends IMMEDIATELY, silently —
      // so nothing may reach the cart unless it would actually schedule.
      //
      // The field is disabled (and empty) under "Send Now", which is the
      // always-valid state. With "Schedule Send" selected, EMPTY is invalid
      // too — the shopper asked to schedule, and letting the add through
      // would send now while the screen says otherwise.
      //
      // ISO yyyy-mm-dd sorts lexicographically, so plain string comparison IS
      // a correct date comparison here, and it sidesteps Date.parse treating a
      // bare date as UTC (which shifts the day for anyone west of Greenwich).
      //
      // The value must clear BOTH the rendered `min` (the shop's tomorrow) and
      // the browser's own today. The rendered attribute can be stale if the
      // page was edge-cached across midnight; the browser check catches that.
      // Taking the stricter of the two only ever rejects a date that would
      // not have scheduled anyway.
      if (this.sendOnField) {
        const scheduleRadio = document.querySelector(
          '[data-gc-send-mode] input[type="radio"][value="schedule"]'
        );
        const scheduling =
          !this.sendOnField.disabled && !!(scheduleRadio && scheduleRadio.checked);
        const chosenDate = this.sendOnField.value;
        // What the shopper can see: typed text that the calendar script
        // could not parse (99/99/9999, an unfinished entry) leaves the ISO
        // input EMPTY but the display full — a FORMAT failure, distinct from
        // both "nothing entered" and "a real date that is too early".
        const typedText = this.sendOnDisplay ? this.sendOnDisplay.value.trim() : '';
        let dateIsValid = true;
        let dateIsEmpty = false;
        let dateIsMalformed = false;

        if (scheduling) {
          if (!chosenDate) {
            dateIsValid = false;
            dateIsEmpty = typedText === '';
            dateIsMalformed = !dateIsEmpty;
          } else if (!/^\d{4}-\d{2}-\d{2}$/.test(chosenDate)) {
            dateIsValid = false;
            dateIsMalformed = true;
          } else {
            const now = new Date();
            const pad = value => (value < 10 ? '0' + value : String(value));
            const browserToday =
              now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
            const minDate = this.sendOnField.min;
            const maxDate = this.sendOnField.max;

            dateIsValid =
              chosenDate > browserToday &&
              (!minDate || chosenDate >= minDate) &&
              (!maxDate || chosenDate <= maxDate);
          }
        }

        if (!dateIsValid) {
          formIsValid = false;
        }

        // Same attempt gate as the recipient fields: an EMPTY date under
        // Schedule Send still blocks the add, but says nothing until the
        // shopper actually tries to add (switching the toggle re-runs this
        // via a dispatched `input`, which must not greet them with an
        // error). A CHOSEN date that fails (past, out of range) errors live.
        const showDateError = !dateIsValid && (attempted || !dateIsEmpty);

        // On the visible input (border, focus target) AND the hidden one
        // (the validated element), so both agree.
        this.sendOnField.setAttribute('aria-invalid', showDateError);
        if (this.sendOnDisplay) {
          this.sendOnDisplay.setAttribute('aria-invalid', showDateError);
        }
        const dateError = this.sendOnField.parentNode.querySelector('.field__error-alert');
        if (dateError) {
          if (showDateError) {
            // Three copies: empty -> required; not a real date -> format,
            // naming the locale's skeleton (the calendar script publishes it
            // on the display as data-gc-format, e.g. DD/MM/YYYY); a real
            // date before tomorrow -> the too-early copy.
            let message;
            if (dateIsEmpty) {
              message = dateError.dataset.requiredText;
            } else if (dateIsMalformed) {
              const skeleton =
                (this.sendOnDisplay && this.sendOnDisplay.getAttribute('data-gc-format')) || '';
              message = (dateError.dataset.formatText || dateError.dataset.invalidText || '')
                .replace('[format]', skeleton)
                .trim();
            } else {
              message = dateError.dataset.invalidText;
            }
            if (message) {
              dateError.textContent = message;
            }
          }
          dateError.style.display = showDateError ? 'block' : 'none';
        }
      }

      form.classList.remove('form--needs-validation');

      if (formIsValid) {
        form.classList.remove('form--invalid');
      } else {
        form.classList.add('form--invalid');
      }
    };

    /**
     * The add to cart button click handler
     */
    Product.prototype.addClickHandler = function(event) {
      // Guard BEFORE preventDefault: if the product data never made it into
      // the variant selector (missing/failed JSON), let the browser submit
      // the form natively — the item is still added to cart via /cart/add,
      // just without the ajax popup, instead of throwing
      // "this.variants.product is undefined" and adding nothing.
      const productData = this.variants && this.variants.product;
      if (!productData || !productData.variants) {
        console.warn('PDP add: product data unavailable, falling back to native form submit');
        return;
      }
      event.preventDefault();
      if (event.target.classList.contains('product--sold-out')) {
        this.showBackInStock();
        return;
      }

      const form = this.container.querySelector('.product__form');

      if ((this.requiredFields && this.requiredFields.length) || this.sendOnField) {
        // Every attempt re-validates the whole form, and the attempt flag is
        // what unlocks the empty-field messages in checkGiftInput. The old
        // shortcut only re-ran validation while `form--needs-validation` was
        // still present — but any keyup consumes that class, and with empty
        // errors now deferred, relying on the stale result could wave a
        // pristine form through.
        this.gcSubmitAttempted = true;
        this.checkGiftInput();

        if (form.classList.contains('form--invalid')) {
          // Stop the click's propagation as well as the add: pdp.js's
          // add-to-bag feedback (initAtbFeedback) listens at DOCUMENT level
          // in the bubble phase and deliberately ignores defaultPrevented
          // (a legitimate AJAX add prevents the default too) — so without
          // this, the pressed/spinner/flying-dot animation played on a
          // click this validation just blocked, selling the shopper an add
          // that never happened. The size gate gives a blocked click the
          // same treatment from the capture side (and raises
          // `pdp:add-blocked`, handled in the constructor, so this
          // validation still runs on an attempt it swallowed).
          event.stopPropagation();
          const firstInvalid = form.querySelector('[aria-invalid="true"]');
          if (firstInvalid) {
            firstInvalid.focus();
          }
          return;
        }
      }

      this.addButtons.forEach(addButton => {
        addButton.classList.add('btn--loading');
      });

      const variant = this.variants.currentVariant;
      const product = this.variants.product;

      const sizeIndex = product.options.indexOf('Size');
      const size = variant['option' + (sizeIndex + 1)];
      let description;
      if (window.theme.template === 'product.gift-card') {
        description = 'Amount: ' + size;
      } else {
        description = 'Size: ' + size;
      }
      const options = {};

      product.options.forEach((option, index) => {
        options[option] = variant[`option${index + 1}`];
      });

      let max = 999;
      if (
        variant.inventory_management === 'shopify' &&
        variant.inventory_policy === 'deny'
      ) {
        max = variant.inventory_quantity;
      }

      let quantity = 1;
      if (form.quantity) {
        quantity = Number(form.quantity.value);
      }

      let item;
      let properties = {};

      let productCollections = [];
      if (this.variants.product.collections) {
        const collections = this.variants.product.collections;
        productCollections = collections.map(collection => collection.title ? collection.title : collection);
        const collectionHandles = collections.map((c)=> c.handle);
        properties['_collections'] = collectionHandles.sort().toString();
      }
      const getSkuItemTotalQuantity = (cartData, targetSku) => {
        let selectSkuItemQty = 0;
        
        if (!cartData || !cartData.items || !Array.isArray(cartData.items)) {
            console.log("can not got cart data");
            return 0; 
        }

        for (let i = 0; i < cartData.items.length; i++) {
            const currentItem = cartData.items[i]; 
            if (currentItem && currentItem.sku && currentItem.sku === targetSku) {
                selectSkuItemQty += (typeof currentItem.quantity === 'number' ? currentItem.quantity : 0);
            }
        }

    
        return selectSkuItemQty;
      }
      const getProductInventoryStock = () => {
        const skuParagraph = $('#tab-pd').find('p.product-sku');
        
        // Check if the SKU paragraph exists and has the data attribute
        if (skuParagraph.length > 0) {
            const retrievedSkuShippingQty = skuParagraph.data('shipping-stock-qty');
            return retrievedSkuShippingQty || max;
        } else {
            return null
        }
      }
      function isActualNumber(value) {

          if (typeof value !== 'number') {
              return false;
          }

          if (isNaN(value)) {
              return false;
          }

          return true;
      };
      function isItemEmptyObject(obj) {
        
        if (obj === null || typeof obj === 'undefined') {
          return true; 
        }

        
        if (typeof obj !== 'object') {
          return false;
        }

      
        if (Array.isArray(obj)) {
          return false; 
        }

        return Object.keys(obj).length === 0;
      };

      let readyToAdd = true;
      let actualAddedQuantity = 0; 
      if (this.offer) {
        // check stock if bopis enable
        
        if (window.theme.settings.enable_bopis) {
        console.log('Checking stock for BOPIS enabled...');
          let itemQty = getSkuItemTotalQuantity(theme.sideCart.cart, variant.sku);
          const inputQuantity = quantity;
          const itemQtyInStock = getProductInventoryStock();
          
          
          const availableQty = Number(itemQtyInStock) - Number(itemQty);

          

          if (!isActualNumber(itemQtyInStock) || (availableQty >= inputQuantity && availableQty >= 0)) {
            
            readyToAdd = true;
            actualAddedQuantity = inputQuantity;
          } else if (!isActualNumber(itemQtyInStock) || (availableQty <= inputQuantity && availableQty >= 0 && itemQtyInStock > 0))  {
            readyToAdd = false;
            actualAddedQuantity = availableQty;
          } else {
            actualAddedQuantity = 0;
            readyToAdd = false;
          }
        } else {
          readyToAdd = true;
        }


        const needCheckQuantity = window.theme.settings.enable_bopis ?  actualAddedQuantity : quantity;
        const quantities = this.checkMultibuyQty(needCheckQuantity);
        const allItems = [];
        for (let j = 0; j < quantities.length; j++) {
          let rawImage1 = variant.featured_image || this.data.images[0];
          let imageSrc1 = '';
          if (typeof rawImage1 === 'string') {
            imageSrc1 = rawImage1;
          } else if (rawImage1 && typeof rawImage1.src === 'string') {
            imageSrc1 = rawImage1.src;
          }

          // Gather the data of the item
          item = {
            id: Number(form.id.value),
            product_id: this.variants.product.id,
            quantity: quantities[j],
            price: Number(variant.price),
            line_price: Number(variant.price),
            compare_price: Number(variant.compare_at_price),
            title: this.variants.product.title,
            vendor: this.variants.product.vendor,
            collections: productCollections,
            description: description,
            url: this.data.url + '?variant=' + variant.id,
            image: imageSrc1,
            min: 0,
            max: max,
            sku : variant.sku
          };

          // Look for form items with a name starting with "properties"
          const propertyInputs = document.querySelectorAll('[name*="properties"]');
          const length = propertyInputs.length;

          // Push all the found properties into an object
          for (let i = 0; i < length; i++) {
            if (propertyInputs[i].value) {
              let propertyName = propertyInputs[i].name;
              propertyName = propertyName.substring(11, propertyName.length - 1);
              properties[propertyName] = propertyInputs[i].value;
            }
          }

          if (this.offer) {
            const offer = `${this.offerItems}-${this.offerMoney}`;
            properties._offer = this.getUniqueOffer(offer, quantities[j]);
          }

          const tags = product.tags.map(tag => tag.toLowerCase());
          const discountTag = tags.find(tag => tag.includes('discount:'));
          if (discountTag) {
            properties["_tagDiscount"] = discountTag;
          }

          const discountBuyGetTag = tags.find(tag => tag.includes('discountbuyget:'));
          if (discountBuyGetTag) {
            properties._tagDiscountBuyGet = discountBuyGetTag;
          }

          // If there were properties, attach them to the data to send
          if (Object.keys(properties).length) {
            item.properties = properties;
          }
          // Add the item to the cart, the cart will deal with adding it to shopify
          if (quantities.length === 1) {
            theme.sideCart.addItem(item);
          } else {
            allItems.push(item);
            item = {};
            properties = {};
            // setTimeout(function() {
            //   theme.sideCart.addItem(item);
            // }, j * (j * 2000));
          }
        }
        theme.sideCart.addItems(allItems);
      } else {
        console.log('Checking stock for BOPIS disabled...');
        let rawImage2 = variant.featured_image || this.data.images[0];
        let imageSrc2 = '';
        if (typeof rawImage2 === 'string') {
          imageSrc2 = rawImage2;
        } else if (rawImage2 && typeof rawImage2.src === 'string') {
          imageSrc2 = rawImage2.src;
        }

        // Gather the data of the item
        item = {
          id: Number(form.id.value),
          product_id: Number(product.id),
          quantity: quantity,
          price: Number(variant.price),
          line_price: Number(variant.price),
          compare_price: Number(variant.compare_at_price),
          title: this.variants.product.title,
          vendor: this.variants.product.vendor,
          collections: productCollections,
          description: description,
          url: this.data.url + '?variant=' + variant.id,
          image: imageSrc2,
          options: options,
          min: 0,
          max: max,
          sku : variant.sku
        };

        // Look for form items with a name starting with "properties"
        const propertyInputs = document.querySelectorAll('[name*="properties"]');
        const length = propertyInputs.length;

        // Push all the found properties into an object
        for (let i = 0; i < length; i++) {
          // Disabled inputs are out of the order — mirrors the native form
          // submit, which never serialises them. The gift-card form disables
          // the hidden recipient fields ("Myself") and the hidden date row
          // ("Send Now") precisely so their kept-for-toggling-back values
          // cannot post.
          if (propertyInputs[i].disabled) {
            continue;
          }
          if (propertyInputs[i].value) {
            let propertyName = propertyInputs[i].name;
            propertyName = propertyName.substring(11, propertyName.length - 1);
            if (propertyName === '_greeting') {
              properties[propertyName] = propertyInputs[i].value.replace(
                /(\r\n\t|\n|\r\t)/gm,
                ''
              );
            } else {
              properties[propertyName] = propertyInputs[i].value;
            }
          }
        }

        const tags = product.tags.map(tag => tag.toLowerCase());
        const discountTag = tags.find(tag => tag.includes('discount:'));
        if (discountTag) {
          properties["_tagDiscount"] = discountTag;
        }

        const discountBuyGetTag = tags.find(tag => tag.includes('discountbuyget:'));
        if (discountBuyGetTag) {
          properties._tagDiscountBuyGet = discountBuyGetTag;
        }

        // If there were properties, attach them to the data to send
        if (Object.keys(properties).length) {
          item.properties = properties;
        }

        // Add the item to the cart, the cart will deal with adding it to shopify
        
        
        
        
        if (window.theme.settings.enable_bopis) {
        
          let itemQty = getSkuItemTotalQuantity(theme.sideCart.cart, item.sku);
          const itemQtyInStock = getProductInventoryStock();
          
          
          const availableQty = Number(itemQtyInStock) - Number(itemQty);

          

          if (!isActualNumber(itemQtyInStock) || (availableQty >= item.quantity && availableQty >= 0)) {
            theme.sideCart.addItem(item);
            readyToAdd = true;
            actualAddedQuantity = item.quantity;
          } else if (!isActualNumber(itemQtyInStock) || (availableQty <= item.quantity && availableQty >= 0 && itemQtyInStock > 0))  {
            item.quantity = availableQty;
            theme.sideCart.addItem(item);
            theme.sideCart.refreshCart();
            readyToAdd = false;
            actualAddedQuantity = availableQty;
          } else {
            actualAddedQuantity = 0;
            readyToAdd = false;
          }
          
        } else {
          theme.sideCart.addItem(item);
          readyToAdd = true;
        }
      
      }

      if (window.theme.settings.enable_bopis) {
        function addWarningToProductQuantity( option = 'display') {
          if (option !== 'display') {
            $('#shipping-out-stock-warning-msg').remove();
            return; // Exit if the option is to hide the warning
          }
          const isMobile = window.innerWidth <= 989; // Adjust the breakpoint as needed
          let $targetButton = $('.product-form__add-to-cart > .product-form__add');
          // if (isMobile) {
          //   $targetButton = $('.product-form__add-to-cart .product-form__quantity');
          // } else {
          //   $targetButton = $('.product-form__add-to-cart .product-form__add');
          // }
        

          if ($targetButton.length === 0) {
              console.log("WARN: Specified button (button.smartwishlist within quantity div) not found in the given context.");
              return; // Exit if the button isn't found
          }
          const $existingWarningSpan = $('#shipping-out-stock-warning-msg');

          if ($existingWarningSpan.length > 0) {
              console.log("Warning message already exists. Not adding a duplicate.");
              return; // Exit the function if the warning is already there
          }
        
          const $warningSpan = $('<span id="shipping-out-stock-warning-msg">'+ theme.settings.bopis_shipping_out_stock_pdp_notice +'</span>');

          // 3. Apply CSS styles to the warning span
          $warningSpan.css({
              'color': '#D2140A',          // Hex color for red
              'font-family': '"futura-pt"', // Font family
              'font-size': '12px',         // Font size
              'font-style': 'normal',      // Normal font style
              'font-weight': '500',        // Medium font weight
              'line-height': '16px',
              'width': '100%',        // Line height
          });

          // 4. Insert the warning span right after the target button
          $targetButton.after($warningSpan);
          

        }
        const $quantitySelectorDiv = $('.quantity-selector.quantity-selector--large');

        if (readyToAdd) {
          if ($quantitySelectorDiv.length) {
            $quantitySelectorDiv.css('border', '1px solid #333');
            addWarningToProductQuantity('hide');
          }
        } else {
          if ($quantitySelectorDiv.length) {
            $quantitySelectorDiv.css('border', '1px solid #D2140A');
          }
          addWarningToProductQuantity('display');
          
        }
        
        const isItemObjEmpty = isItemEmptyObject(item);
        
        let rawImage3 = this.data.images[0];
        let imageSrc3 = '';
        if (typeof rawImage3 === 'string') {
          imageSrc3 = rawImage3;
        } else if (rawImage3 && typeof rawImage3.src === 'string') {
          imageSrc3 = rawImage3.src;
        }

        const popupData = {
          title: isItemObjEmpty ? this.variants.product.title : item.title,
          image: imageSrc3,
          price: isItemObjEmpty ? Number(variant.price) : item.price,
          compare_price: isItemObjEmpty ? Number(variant.compare_at_price) : item.compare_price,
          quantity: isItemObjEmpty ? quantity: item.quantity,
          vId: isItemObjEmpty ? Number(variant.id) : item.id
        };
        if (!readyToAdd && actualAddedQuantity <= 0) {
          this.addButtons.forEach(addButton => {
            addButton.classList.remove('btn--loading');
          });
          return;

        } else {
          popupData.quantity = actualAddedQuantity;
        }
        if (options.Size) {
          popupData.size = options.Size;
        }

        setTimeout(function() {
          updateCartPopup(popupData);
        }, 1000);
        
      } else {
        theme.sideCart.openDrawer();
      }
      

      if (this.offer) {
        let preExistingItems = 1;
        // if (theme.sideCart.cart.item_count >= 1) {
        //   theme.sideCart.cart.items.forEach(lineItem => {
        //     if (lineItem.properties.hasOwnProperty('_offer') && lineItem.properties._offer === this.offer) {
        //       preExistingItems += lineItem.quantity;
        //     }
        //   });
        // }
        // let itemsToAdd = this.offerItems - preExistingItems;
        if (this.offerPopupMessage) {
          if (preExistingItems >= this.offerItems) {
            this.offerPopupMessage.innerHTML =
              'Congratulations you have met the requirements for this offer';
          } else {
            // this.offerPopupMessage.innerHTML = `This product is part of an offer: ${this.offerItems} for $${this.offerMoney} add ${itemsToAdd} more items to receive this offer.`;
            this.offerPopupMessage.innerHTML = `This product is part of an offer: ${
              this.offerItems
            } for ${window.theme.store === 'GB' ? '£' : '$'}${this.offerMoney}.`;
          }
        }
        if (this.offerPopupLink) {
          this.offerPopupLink.attributes.href = `/collections/${this.offer}`;
          this.openOfferPopup();
        }
      }
      this.addButtons.forEach(addButton => {
        addButton.classList.remove('btn--loading');
      });
    };

    /**
     * Deal with the image carousels
     * @todo we need a better method than hiding the thumbs with css
     */

    Product.prototype.initImageCarousels = function() {
      let productImages = this.$container.find('.product__images');
      let productThumbnails = this.$container.find('.product__thumbnails');
      let $status = this.$container.find('.pdp-product__images--paging-info');
      let initialSlide = 0;
      let firstRender = 0;

      $(document).ready(function() {
        $('.product__images--popups').magnificPopup({
          delegate: 'a',
          type: 'image',
          image: {
          markup: `<div class="mfp-figure">
            <div class="mfp-close"></div>
            <div class="mfp-img"></div>
            <div class="mfp-prev"></div>
            <div class="mfp-next"></div>
            <div class="mfp-bottom-bar">
              <div class="mfp-title"></div>
              <div class="mfp-counter"><span class="current-slide-count">1</span> / 1</div>
            </div>
          </div>`,
          },
          gallery: {
            enabled: true,
            tCounter: '<span class="current-slide-count">%curr%</span> / %total%',
          },
          callbacks: {
            change: function () {
              let interaction_type = "change";
              if (firstRender == 0) {
                interaction_type = "Zoom";
                firstRender = 1;
              }
              const currentSlideCount = this.index + 1;
              dataLayerPDPInterfaceObj.push({ product_image_state: null });
              dataLayerPDPInterfaceObj.push({
                event: "product_image_interaction",
                interaction_type: interaction_type,
                product_image_state: {
                  index: currentSlideCount,
                },
              });
            },
          },
        });

        var magnificPopup = $.magnificPopup.instance; // save instance in magnificPopup variable

        $(document).on("click", ".mfp-prev", function() {
          magnificPopup.prev();
        });

        $(document).on("click", ".mfp-next", function() {
          magnificPopup.next();
        });

      });

      if (productImages.find('.product__image').length === 1) {
        return;
      }

      productImages.on(
        "init reInit afterChange",
        function (event, slick, currentSlide, nextSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          $status.html(
            `<span class="current-slide-count">${i}</span> / ${slick.slideCount}`
          );
        }
      );

      productImages.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          if (initialSlide != currentSlide) {
            const pdpImageEventObj = {
              event: "product_image_interaction",
              interaction_type: "Change",
              product_image_state: {
                index: currentSlide + 1,
              },
            };
            initialSlide = currentSlide;
            setPDPDataLayerEvents(pdpImageEventObj, "product_image_state");
          }
        }
      );

      // Carousel for main image
      productImages.slick({
        accessibility: true,
        arrows: true,
        asNavFor: productThumbnails,
        dots: false,
        lazyLoad: 'progressive',
        swipeToSlide: true,
        infinite: false,
        rows: 0,
        responsive: [
          {
            breakpoint: Number(theme.settings.grid_medium),
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      });

      // Carousel for thumbnails
      if (productThumbnails) {
        productThumbnails.slick({
          accessibility: false,
          arrows: false,
          prevArrow: $('.product .prevButton'),
          nextArrow: $('.product .nextButton'),
          asNavFor: productImages,
          centerMode: false,
          focusOnSelect: true,
          verticalSwiping: true,
          slidesToShow: 4.5,
          slidesToScroll: 1,
          vertical: true,
          infinite: false,
          rows: 0,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 5
              },
            },
          ],
        });
      }
    };

    /**
     * Display featured image for the selected variant.
     */
    Product.prototype.updateImages = function (event) {
      const variant = event.variant;

      // return if featured_image object not available
      if (!variant.featured_image) {
        return;
      }

      // Grab variant featured image ID
      const imageId = variant.featured_image.id;
      const productImages = $('.product__images');
      const productThumbnails = $('.product__thumbnails');

      // Check if main product image slider is initialized
      if (!productImages.hasClass('slick-initialized')) {
        return;
      }

      // Get slide index using featured image ID
      const slickIndex = $("[data-imgid='" + imageId + "']:not('.slick-cloned')").data("slickIndex");

      if (typeof(slickIndex) != 'undefined') {
        // Set variant featured image as active slide for main image slider
        productImages.slick("slickGoTo", slickIndex);
      }


      // Check if product thumbnails image slider is initialized
      if (!productThumbnails.hasClass('slick-initialized')) {
        return;
      }

      // Get thumbnails slide index using featured image ID
      const thumbSlickIndex = $("[data-thumbimgid='" + imageId + "']:not('.slick-cloned')").data("slickIndex");

      if (typeof(thumbSlickIndex) != 'undefined') {
        // Set variant featured image as active slide for thumbnails image slider
        productThumbnails.slick("slickGoTo", thumbSlickIndex);
      }
    };

    /**
     * Deal with the image zoom on mouseover
     */

    Product.prototype.initImageZoom = function() {
      const productImagesZoom = document.querySelector('.product__images--zoom');

      if (!productImagesZoom) {
        return;
      }

      const productImages = productImagesZoom.querySelectorAll('img');
      const productZoomInstances = [];

      const initZoom = () => {
        productImages.forEach(image => {
          const imageZoom = new Drift(image, {
            paneContainer: image.parentNode,
            inlinePane: false,
            zoomFactor: 2,
            onHide: function() {
              $('.drift-opening img').attr('style', '');
            }
          });

          productZoomInstances.push(imageZoom);
        });
      };

      const initPopup = () => {
        $('.product__images--zoom').magnificPopup({
          delegate: 'img',
          type: 'image',
          disableOn: () => {
            return $(window).width() < parseInt(window.theme.settings.grid_medium);
          },
          gallery: {
            enabled: true,
          }
        });
      };

      const desktopQuery = window.matchMedia(`(min-width: ${window.theme.settings.grid_medium}px)`);
      if (desktopQuery.matches) {
        initZoom();
      } else {
        initPopup();
      }

      desktopQuery.addListener(event => {
        if (event.matches) {
          initZoom(); // Init image zoom
        } else {
          initPopup();  // Init popup zoom
          productZoomInstances.forEach(instance => instance.destroy());  // Disable image zoom
        }
      });
    };

    /**
     * Deal with the related products carousel
     */
    Product.prototype.initRelatedProducts = function() {
      // Are there related products?
      const $relatedProducts = $('.related-products__container');
      if (!$relatedProducts.length) {
        return;
      }

      let isInited = false;

      // Use a carousel at mobile size, kill it otherwise
      function onResize() {
        var clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        $('.product__thumbnails').slick('setPosition');
        if (isInited) {
          if (clientWidth >= Number(theme.settings.grid_medium)) {
            $relatedProducts.slick('unslick');
            isInited = false;
          }
        } else if (clientWidth < Number(theme.settings.grid_medium)) {
          $relatedProducts.slick({
            accessibility: false,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            variableWidth: true,
            swipeToSlide: true,
            rows: 0,
          });
          isInited = true;
        }
      }

      window.addEventListener('resize', onResize);
      onResize();
    };

    Product.prototype.openOfferPopup = function() {
      if (this.offerPopup) {
        // Store the currently focused element
        window.theme.lastActiveElement = document.activeElement;

        this.offerPopup.classList.add('multibuy-offer__popup--expanded');
        this.offerPopup.setAttribute('aria-hidden', 'false');

        // Set focus to the modal for accessibility
        const modalCloseButton = this.offerPopup.querySelector('.multibuy-offer__popup--close');
        if (modalCloseButton) {
          modalCloseButton.focus();
        }

        // Close on ESC pressed
        $(document).on('keydown:escape', this.toggleOfferPopup.bind(this));
      }
    };

    Product.prototype.toggleOfferPopup = function(event) {
      if (event && event.type !== 'keydown:escape') {
        event.preventDefault();
      }
      if (this.offerPopup) {
        if (
          this.offerPopup.classList.contains('multibuy-offer__popup--expanded')
        ) {
          // Restore focus to the opener element
          if (window.theme.lastActiveElement) {
            window.theme.lastActiveElement.focus();
            window.theme.lastActiveElement = null;
          }

          this.offerPopup.classList.add('multibuy-offer__popup--expanded');
          this.offerPopup.setAttribute('aria-hidden', 'true');

          // Remove escape event listener
          $(document).off('keydown:escape', this.toggleOfferPopup.bind(this));
        } else {
          // Store the currently focused element
          window.theme.lastActiveElement = document.activeElement;

          this.offerPopup.classList.remove('multibuy-offer__popup--expanded');
          this.offerPopup.setAttribute('aria-hidden', 'false');

          // Set focus to the modal for accessibility
          const modalCloseButton = this.offerPopup.querySelector('.multibuy-offer__popup--close');
          if (modalCloseButton) {
            modalCloseButton.focus();
          }

          // Close on ESC pressed
          $(document).on('keydown:escape', this.toggleOfferPopup.bind(this));
        }
      }
    };

    Product.prototype.toggleShippingInfoPopup = function(event) {
      const modal = document.querySelector('[data-shipping-delivery-modal]');
      const rcTriggers = document.querySelectorAll('[data-shipping-delivery-trigger]');
      const closeModalButtons = document.querySelectorAll('[data-close-shipping-delivery]');
      if (!modal || !rcTriggers.length) return;

      function closeShippingModal() {
        // Restore focus to the opener element
        if (window.theme.lastActiveElement) {
          window.theme.lastActiveElement.focus();
          window.theme.lastActiveElement = null;
        }

        document.querySelector("body").classList.remove("stopScrolling");
        modal.classList.remove('shipping-delivery-modal--visible');
        modal.setAttribute('aria-hidden', 'true');

        // Remove escape event listener
        $(document).off('keydown:escape', closeShippingModal);
      }

      rcTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          // Store the currently focused element
          window.theme.lastActiveElement = document.activeElement;

          modal.classList.add('shipping-delivery-modal--visible');
          modal.setAttribute('aria-hidden', 'false');
          document.querySelector("body").classList.add("stopScrolling");

          // Set focus to the modal for accessibility
          const modalCloseButton = modal.querySelector('.shipping-delivery-modal__close');
          if (modalCloseButton) {
            modalCloseButton.focus();
          }

          // Close on ESC pressed
          $(document).on('keydown:escape', closeShippingModal);
        });
      });
      if (closeModalButtons.length) {
        closeModalButtons.forEach(closeButton => {
          closeButton.addEventListener('click', closeShippingModal);
        });
      }

      $(document).on("click", ".pdp-shipping-policy h2", function (e) {
        e.preventDefault();
        $(".pdp-shipping-policy").removeClass("active");
        $(".pdp-shipping-policy h2").removeClass("active");
        $(this).addClass("active");
        if ($(this).hasClass("policy-first")) {
          $(".pdp-shipping-policy-first").addClass("active");
        } else {
          $(".pdp-shipping-policy-last").addClass("active");
        }
      })
    }

    return Product;
  })();

  function formatPriceWithSup(price) {
    const formatted = slate.Currency.formatMoney(price, window.theme.moneyFormat).replace(/<\/?[^>]+(>|$)/g, "");
    const symbol = window.theme.currentCurrencySymbol;
    if (formatted.includes(symbol)) {
      return formatted.replace(symbol, `<em class="currency-symbol">${symbol}</em>`);
    }
    return `<em class="currency-symbol">${symbol}</em>${slate.Currency.removeCurrencySymbol(formatted)}`;
  }

  function checkAfterShipProducts(eventId){
    console.log('eventId',eventId);
    window.theme.azRelatedProducts = window.theme.azRelatedProducts || {};
    const relatedSections = document.querySelectorAll(`[data-personalization-id="${eventId}"]`);
    Array.from(relatedSections).forEach(function(section){
      let productItems = section.querySelectorAll('.apz_product_item');
        Array.from(productItems).forEach(function(productItem){
          let productHandle = productItem.dataset.apzUpsellProductHandle;
          let productData = window.theme.azRelatedProducts[productHandle];
          if(productData != undefined){
            if(productData.variants.length > 1){
              updateAfterShipProductItem(productItem,productData)
            }
          }
          else{
            fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(data => {
              window.theme.azRelatedProducts[productHandle] = data;
              if(data.variants.length > 1){
                updateAfterShipProductItem(productItem,data);
              }
            });
          }
        })
    })
  }

  function updateAfterShipProductItem(product,data){
    let priceSelector = product.querySelector('.am_rec_item_price');
    if(!priceSelector) return;
    var sortedVariants = data.variants.sort((a, b) => {
      return a.price - b.price;
    });
    var firstAvailableVariant = sortedVariants.find(variant => variant.available === true);
    if(firstAvailableVariant){
      price = firstAvailableVariant.price;
      priceSelector.innerHTML = formatPriceWithSup(price);
    }
  }
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Product script loaded');
    const afterShipRecommendations = document.querySelectorAll('[data-personalization-id]');
    Array.from(afterShipRecommendations).forEach(function(recommendation) {
      let observer = new MutationObserver(function(mutations) {
      for(var mutation of mutations) {
        console.log('Mutation detected:', mutation);
          if (mutation.type === 'childList' && recommendation.innerHTML.trim() !== '') {
            let priceWrappers = recommendation.querySelectorAll('.am_rec_item_price,.am_rec_item_price');
            console.log('Product items found:', priceWrappers);
            Array.from(priceWrappers).forEach(function(priceWrapper) {
              const price = parseFloat(priceWrapper.textContent.replace(/[^0-9.]/g, '')) * 100;
              priceWrapper.innerHTML = formatPriceWithSup(price);
            })
            observer.disconnect(); // Stop observing after the first mutation
          }
        }
      })
      observer.observe(recommendation, {
        childList: true,
        subtree: true
      });
    })
      // theme.CurrencySwitcher.switchCurrency(cartOfferElements)
  })
  window.theme.sections.register('product', theme.Product);
  window.theme._registeredSections['product'] = true;
}

window.recentProducts = {
  get: () => {
    const storage = localStorage.getItem('recentlyViewedProducts') || '[]';
    return JSON.parse(storage)
  },
  set: (input) => {
    if( !input.handle || !input.id ) throw Error("Recent products - Handle or id missing")
    const limit = 6;
    let recentProducts = window.recentProducts.get();

    // Remove current product from recently viewed to push it to front
    recentProducts = recentProducts.filter((product) => {
      return product.id !== input.id && product.handle !== input.handle;
    });
    // Add current product to the start of the array
    recentProducts.unshift({
      id: input.id,
      handle: input.handle
    });
    // Cut the array down so we dont store a humungous amount of data
    recentProducts = recentProducts.splice(0, limit * 2);
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentProducts));
  }
}